<template>
  <div>
    <v-data-table
      colspan="100%"
      :headers="headers"
      :items="items"
      :acesso-delete="acessoDelete"
      :footer-props="{
        'items-per-page-text':'Linhas por página',
        'page-text': '{0}-{1} de {2}',
        'items-per-page-all-text': 'Todos',
      }"
      no-data-text="Sem dados"
    >
      <template #item.nome="{ item }">
        <v-list-item class="ml-n4">
          <div class="d-flex align-center">
            <v-avatar
              :color="`${$vuetify.theme.dark ? 'primary' : '#DCDCDC'}`"
              size="32"
            >
              <span
                :class="`${$vuetify.theme.dark ? 'white--text' : 'primary--text'} font-weight-bold
                `"
              >
                {{ item.nome.toUpperCase().charAt(0) }}{{ item.nome.toUpperCase().charAt(1) }}
              </span>
            </v-avatar>

            <div class="d-flex flex-column ms-3">
              {{ item.nome }}
            </div>
          </div>
        </v-list-item>
      </template>

      <template #item.atuacaoNome="{ item }">
        <v-chip :color="item.atuacaoNome ? 'primary' : 'error'">
          {{ item.atuacaoNome }}
        </v-chip>
      </template>

      <template #item.actions="{ item }">
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              class="ml-n5"
              v-on="on"
              color="primary"
            >
              <v-icon>{{ icons.mdiDotsVertical }}</v-icon>
            </v-btn>
          </template>
          <v-list
            v-if="acessoDelete"
          >
            <v-list-item>
              <v-list-item-title
                role="button"
                @click="desassociarItem(item)"
              >
                <v-icon
                  size="20"
                  class="me-2"
                >
                  {{ icons.mdiCloseThick }}
                </v-icon>

                <span>Desassociar</span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>

    <!-- dialog -->
    <v-dialog
      v-model="dialogDesassociar"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-card-title class="headline">
          Desassociação
        </v-card-title>

        <v-card-text>
          Tem certeza que vai fazer está desassociação?
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="error"
            outlined
            @click="closeDelete"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="success"
            @click="confirmarDesassociacao"
          >
            <v-progress-circular
              v-if="loading"
              indeterminate
              color="secundary"
            ></v-progress-circular>
            <span v-else>OK</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mdiCloseThick, mdiDelete, mdiDotsVertical } from '@mdi/js'
import router from '@/router'
import EquipeService from '@/services/modules/EquipeService'

export default {
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    headers: {
      type: Array,
      default: () => {},
    },
    acessoDelete: {
      type: Boolean,
      default: true,
    },
  },

  data: () => ({
    dialogDesassociar: false,
    dialogInativar: false,
    loading: false,
    icons: {
      mdiDelete,
      mdiDotsVertical,
      mdiCloseThick,
    },
    idEquipe: 0,
  }),

  methods: {
    confirmarDesassociacao() {
      this.loading = true
      EquipeService
        .deleteEquipeIntegrante(this.idEquipe, this.idIntegrante)
        .then(() => {
          this.closeDelete()
          this.$toast.success('Desassociação feita com sucesso.')
          this.loading = false
          this.$emit('refetch-data')
        })
        .catch(() => {
          this.closeDelete()
          this.loading = false
        })
    },

    desassociarItem(item) {
      this.idEquipe = router.currentRoute.params.id
      this.idIntegrante = item.idIntegrante
      this.dialogDesassociar = true
    },

    closeDelete() {
      this.dialogDesassociar = false
    },
  },
}
</script>
